const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const toApiDate = (v) => {
    const [y, m, d] = String(v || '').split('-');
    return y && m && d ? `${d}-${m}-${y}` : '';
};

export const toInputDate = (v) => {
    const [d, m, y] = String(v || '').split('-');
    return d && m && y ? `${y}-${m}-${d}` : '';
};

export const fmtApiDate = (v) => {
    const [d, m, y] = String(v || '').split('-');
    const mi = Number(m) - 1;
    return d && MONTHS[mi] && y ? `${d} ${MONTHS[mi]} ${y}` : '';
};

export const numOrNull = (v) => {
    const s = String(v ?? '').trim();
    if (!s) return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
};

export const txt = (v) => String(v ?? '').trim();
